import request from '@/utils/request';

/**
 * 备忘录相关 API
 */

/**
 * 创建备忘录
 * @param {Object} data - 备忘录数据
 * @param {string} data.title - 备忘录标题（必填）
 * @param {number} data.type - 类型 0-全局备忘录 1-本书备忘录（必填）
 * @param {string} [data.content] - 备忘录内容（Markdown格式）
 * @param {number} [data.folderId] - 所属文件夹ID（为空表示未归档）
 * @param {number} [data.workId] - 关联作品ID（type=1时必填）
 * @returns {Promise}
 */
export function createMemo(data) {
  return request({
    url: '/user/memo/create',
    method: 'post',
    data
  });
}

/**
 * 删除备忘录
 * @param {Object} data
 * @param {number} data.id - 备忘录ID
 * @returns {Promise}
 */
export function deleteMemo(data) {
  return request({
    url: '/user/memo/delete',
    method: 'post',
    data
  });
}

/**
 * 查询备忘录详情
 * @param {Object} data
 * @param {number} data.id - 备忘录ID
 * @returns {Promise}
 */
export function getMemoDetail(data) {
  return request({
    url: '/user/memo/detail',
    method: 'post',
    data
  });
}

/**
 * 编辑备忘录
 * @param {Object} data
 * @param {number} data.id - 备忘录ID（必填）
 * @param {string} data.title - 备忘录标题（必填）
 * @param {string} [data.content] - 备忘录内容（Markdown格式）
 * @returns {Promise}
 */
export function updateMemo(data) {
  return request({
    url: '/user/memo/update',
    method: 'post',
    data
  });
}

/**
 * 分页查询备忘录列表
 * @param {Object} params
 * @param {number} params.type - 类型 0-全局备忘录 1-本书备忘录
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页数量
 * @param {number} [params.folderId] - 文件夹ID（为空查未归档）
 * @param {string} [params.title] - 标题关键词（模糊查询）
 * @param {number} [params.workId] - 关联作品ID（type=1时必填）
 * @returns {Promise}
 */
export function getMemoList(params) {
  return request({
    url: '/user/memo/page',
    method: 'post',
    data: params
  });
}

/**
 * 备忘录置顶/取消置顶
 * @param {Object} data
 * @param {number} data.id - 备忘录ID
 * @returns {Promise}
 */
export function toggleMemoTop(data) {
  return request({
    url: '/user/memo/pin',
    method: 'post',
    data: {
      id: data.id
    }
  });
}

/**
 * 移动备忘录到文件夹
 * @param {Object} data
 * @param {number} data.id - 备忘录ID
 * @param {number} [data.folderId] - 目标文件夹ID（为空表示移至未归档）
 * @returns {Promise}
 */
export function moveMemoToFolder(data) {
  return request({
    url: '/user/memo/moveToFolder',
    method: 'post',
    data: {
      id: data.id,
      folderId: data.folderId || null
    }
  });
}

/**
 * 创建备忘录文件夹
 * @param {Object} data
 * @param {string} data.folderName - 文件夹名称
 * @param {number} data.type - 类型 0-全局备忘录 1-本书备忘录
 * @param {number} [data.sortOrder] - 排序（越小越靠前，默认为0）
 * @param {number} [data.workId] - 关联作品ID（type=1时必填）
 * @returns {Promise}
 */
export function createMemoFolder(data) {
  return request({
    url: '/user/memo/folder/create',
    method: 'post',
    data
  });
}

/**
 * 删除备忘录文件夹
 * @param {Object} data
 * @param {number} data.id - 文件夹ID（必填）
 * @returns {Promise}
 */
export function deleteMemoFolder(data) {
  return request({
    url: '/user/memo/folder/delete',
    method: 'post',
    data: {
      id: data.id
    }
  });
}

/**
 * 查询备忘录文件夹列表
 * @param {Object} data
 * @param {number} data.type - 类型 0-全局备忘录 1-本书备忘录
 * @param {number} [data.workId] - 关联作品ID（type=1时必填）
 * @returns {Promise}
 */
export function getMemoFolderList(data) {
  return request({
    url: '/user/memo/folder/list',
    method: 'post',
    data
  });
}

/**
 * 编辑备忘录文件夹
 * @param {Object} data
 * @param {number} data.id - 文件夹ID（必填）
 * @param {string} data.folderName - 文件夹名称（必填，最大50字符）
 * @param {number} [data.sortOrder] - 排序（越小越靠前）
 * @returns {Promise}
 */
export function updateMemoFolder(data) {
  return request({
    url: '/user/memo/folder/update',
    method: 'post',
    data: {
      id: data.id,
      folderName: data.folderName,
      sortOrder: data.sortOrder
    }
  });
}
